import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as RocketIcon } from "./assets/rocket.svg";

export const AnonymousSelectEntityPlaceholder: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="flex h-full items-center justify-center gap-3 px-6">
      <RocketIcon />
      <span className="font-secondary text-sm font-medium text-white">
        {t({ id: "common.my-workspace", defaultMessage: "My workspace" })}
      </span>
    </div>
  );
};
